import { render, staticRenderFns } from "./FilesHeader.vue?vue&type=template&id=6493a042&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6493a042')) {
      api.createRecord('6493a042', component.options)
    } else {
      api.reload('6493a042', component.options)
    }
    module.hot.accept("./FilesHeader.vue?vue&type=template&id=6493a042&", function () {
      api.rerender('6493a042', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/components/approvalFiles/FilesHeader.vue"
export default component.exports